import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { getCsrfToken, ApiError } from '../client';

export interface ChangePasswordPayload {
  current_password: string;
  new_password: string;
  new_password_confirm: string;
}

const meta = import.meta as unknown as { env?: Record<string, string> };
const CENTRIX_BASE = meta.env?.VITE_API_BASE_URL || '/api/centrix/v1';
// Password change uses /user/v1 prefix, distinct from /centrix/v1
const USER_API_BASE = CENTRIX_BASE.replace('/centrix/v1', '') || '/api';

export function useChangePassword() {
  return useMutation<void, ApiError, ChangePasswordPayload>({
    mutationFn: async (data) => {
      const csrfToken = await getCsrfToken();
      try {
        await axios.post(`${USER_API_BASE}/user/v1/account/password`, data, {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken,
          },
        });
      } catch (err) {
        if (axios.isAxiosError(err)) {
          const status = err.response?.status ?? 0;
          const responseData = err.response?.data as Record<string, unknown> | undefined;
          const message =
            (responseData?.detail as string) ||
            (responseData?.message as string) ||
            (responseData?.old_password as string) ||
            err.message ||
            'Password change failed';
          throw new ApiError(status, message, responseData);
        }
        throw err;
      }
    },
  });
}
